import { ColumnDef } from '@tanstack/react-table';
import { MembershipDto } from '@area-restrita/api-client/model/membershipDto';

import CustomerRolesCell from './CustomerRolesCell';
import UsersActionsCell from './UsersActionsCell';

export const columns: ColumnDef<MembershipDto>[] = [
  {
    accessorKey: 'searchTerm',
    meta: { className: 'hidden' },
  },
  {
    accessorKey: 'externalId',
    header: 'Id externo',
  },
  {
    accessorFn: ({ user }) => user.fullName ?? 'N/A',
    header: 'Nome completo',
  },
  {
    accessorFn: ({ user }) => user.email,
    header: 'E-mail',
  },
  {
    accessorKey: 'roles',
    cell: CustomerRolesCell,
    header: 'Funções',
  },
  {
    accessorFn: ({ status }) => status,
    header: 'Status',
    cell: ({
      row: {
        original: { status },
      },
    }) =>
      [
        { label: 'Convidado', value: 'INVITE' },
        { label: 'Ativo', value: 'ACTIVE' },
        { label: 'Inativo', value: 'INACTIVE' },
      ].find((option) => option.value === status)?.label || 'N/A',
  },
  {
    header: 'Ações',
    meta: { className: 'text-right' },
    cell: UsersActionsCell,
  },
];
